import { render, staticRenderFns } from "./WidgetCreatorSecondStep.vue?vue&type=template&id=35cebc86&scoped=true&"
import script from "./WidgetCreatorSecondStep.vue?vue&type=script&lang=js&"
export * from "./WidgetCreatorSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCreatorSecondStep.vue?vue&type=style&index=0&id=35cebc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cebc86",
  null
  
)

export default component.exports